import { useState } from "react";
import apiClient from "../utils/apiClient";

const useApiRequest = (baseUrl = "") => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);
    const [response, setResponse] = useState(null);

    const makeRequest = async (method, url, data = null, config = {}) => {
        setLoading(true);
        setError(null);

        try {
            // Construir URL completa si hay baseUrl
            const fullUrl = baseUrl ? `${baseUrl}${url}` : url;
            let response;

            switch (method.toLowerCase()) {
                case "get":
                    response = await apiClient.get(fullUrl, config);
                    break;
                case "post":
                    response = await apiClient.post(fullUrl, data, config);
                    break;
                case "put":
                    response = await apiClient.put(fullUrl, data, config);
                    break;
                case "patch":
                    response = await apiClient.patch(fullUrl, data, config);
                    break;
                case "delete":
                    response = await apiClient.delete(fullUrl, config);
                    break;
                default:
                    throw new Error(`Método HTTP no soportado: ${method}`);
            }

            // Agregar información del método a la respuesta
            const enhancedResponse = {
                ...response,
                method: method.toLowerCase(),
                url: fullUrl,
                timestamp: new Date().toISOString(),
            };

            setData(response.data);
            setResponse(enhancedResponse);
            return {
                success: true,
                data: response.data,
                response: enhancedResponse,
                method: method.toLowerCase(),
            };
        } catch (error) {
            const finalUrl = baseUrl ? `${baseUrl}${url}` : url;
            console.error(
                `Error en ${method.toUpperCase()} ${finalUrl}:`,
                error
            );
            setError(error);
            return {
                success: false,
                error,
                message:
                    error.response?.data?.message ||
                    error.message ||
                    "Error en la petición",
            };
        } finally {
            setLoading(false);
        }
    };

    // CRUD methods
    const create = (data, config) => makeRequest("post", "", data, config);
    const read = (id = "", config) =>
        makeRequest("get", id ? `/${id}` : "", null, config);
    const update = (id, data, config) =>
        makeRequest("put", `/${id}`, data, config);
    const remove = (id, config) =>
        makeRequest("delete", `/${id}`, null, config);
    const list = (params, config) =>
        makeRequest("get", "", null, { ...config, params });

    const clearError = () => setError(null);
    const resetData = () => setData(null);

    return {
        // Estado
        loading,
        error,
        data,
        response,

        // Método HTTP genérico
        makeRequest,

        // Métodos CRUD
        create,
        read,
        update,
        remove,
        list,

        // Utilidades
        clearError,
        resetData,
        setData,
    };
};

export default useApiRequest;
